module.exports = __webpack_public_path__ + "static/media/battle_cards.cb385bce.png";